import { render, staticRenderFns } from "./select-dropdown-year.vue?vue&type=template&id=104c674b"
import script from "./select-dropdown-year.vue?vue&type=script&lang=js"
export * from "./select-dropdown-year.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports